import { authFetch } from './api';

/** Base path for consolidated `files` Cloud Function (workspace-scoped). */
export function filesCollectionPath(workspaceId: string): string {
  return `/files/${encodeURIComponent(workspaceId)}`;
}

/** Single file path under `files` (detail, PUT, DELETE). */
export function fileItemPath(workspaceId: string, fileId: string): string {
  return `/files/${encodeURIComponent(workspaceId)}/${encodeURIComponent(fileId)}`;
}

/** POST view / play analytics events for a file. */
export function fileItemViewEventsPath(workspaceId: string, fileId: string): string {
  return `/files/${encodeURIComponent(workspaceId)}/${encodeURIComponent(fileId)}/view-events`;
}

/** Partner video lookup under consolidated `files` function. */
export function filesPartnerVideosPath(workspaceId: string, query: Record<string, string>): string {
  const qs = new URLSearchParams(query).toString();
  return `/files/${encodeURIComponent(workspaceId)}/partner-videos${qs ? `?${qs}` : ''}`;
}

/** File translation under consolidated `files` function. */
export function filesTranslatePath(workspaceId: string): string {
  return `/files/${encodeURIComponent(workspaceId)}/translate`;
}

/** PATCH a partial update to a recap file. Only the supplied fields are updated. */
export function patchFile(
  workspaceId: string,
  fileId: string,
  fields: Record<string, unknown>,
  ifMatchEtag?: string,
): Promise<unknown> {
  return authFetch(fileItemPath(workspaceId, fileId), {
    method: 'PATCH',
    body: JSON.stringify({ workspaceId, fileId, ...fields }),
    ...(ifMatchEtag ? { headers: { 'If-Match': ifMatchEtag } } : {}),
  });
}
